import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { usersChartWidth } from "Constants";
import LocaleStrings from "Languages";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

class DashboardUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstload: true,
      data: [],
      hitstype: "weekly",
      totaltoday: 0,
      percentage: 0,
      change: "same",
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.arrangeDataWeekly(this.props.users);
    }, 300);
  }

  arrangeDataWeekly = (data) => {
    var weeks = [
      { name: "MON", hits: 0 },
      { name: "TUE", hits: 0 },
      { name: "WED", hits: 0 },
      { name: "THU", hits: 0 },
      { name: "FRI", hits: 0 },
      { name: "SAT", hits: 0 },
      { name: "SUN", hits: 0 },
    ];
    var weeksWithData = [];
    weeks.map((week, weekindex) => {
      var weekHitsCount = 0;
      data.map((value, index) => {
        var weekDay = moment(value.timestamp).isoWeekday();
        if (weekDay === 0 && weekindex === 6) {
          //Sunday
          weekHitsCount++;
        } else if (weekDay - 1 === weekindex) {
          weekHitsCount++;
        }
      });
      weeksWithData.push({ ...week, hits: weekHitsCount, amt: data.length });
    });

    // debugger;
    var totalToday = 0;
    var totalYesterday = 0;
    var change = "same";
    var weekDay = moment().isoWeekday();
    if (weekDay === 0) {
      //Sunday
      totalYesterday = weeksWithData[5].hits;
      totalToday = weeksWithData[6].hits;
    } else {
      weekDay = weekDay - 1;
      if (weekDay !== 0) totalYesterday = weeksWithData[weekDay - 1].hits;
      totalToday = weeksWithData[weekDay].hits;
    }

    var percentage = 0;
    if (totalToday > totalYesterday) {
      percentage = ((totalToday - totalYesterday) / totalToday) * 100.0;
      change = "higher";
    } else if (totalToday < totalYesterday) {
      percentage = ((totalYesterday - totalToday) / totalYesterday) * 100.0;
      change = "lower";
    }
    percentage = Math.floor(percentage);
    this.setState({
      data: weeksWithData,
      totaltoday: totalToday,
      percentage,
      change,
    });
  };

  arrangeDataMonthly = (data) => {
    var months = [
      { name: "JAN", hits: 0 },
      { name: "FEB", hits: 0 },
      { name: "MAR", hits: 0 },
      { name: "APR", hits: 0 },
      { name: "MAY", hits: 0 },
      { name: "JUN", hits: 0 },
      { name: "JUL", hits: 0 },
      { name: "AUG", hits: 0 },
      { name: "SEP", hits: 0 },
      { name: "OCT", hits: 0 },
      { name: "NOV", hits: 0 },
      { name: "DEC", hits: 0 },
    ];
    var monthsWithData = [];
    var curYear = moment().year();
    months.map((month, monthindex) => {
      var monthHitsCount = 0;
      data.map((value, index) => {
        var dateYear = moment(value.timestamp).year();
        if (curYear === dateYear) {
          //If data belongs to same year
          var monthDay = moment(value.timestamp).month();
          // if((monthDay-1) === monthindex){
          if (monthDay === monthindex) {
            monthHitsCount++;
          }
        }
      });
      monthsWithData.push({ ...month, hits: monthHitsCount, amt: data.length });
    });

    // debugger;
    var totalThisMonth = 0;
    var totalLastMonth = 0;
    var change = "same";
    var monthDay = moment().month();
    // monthDay=monthDay-1;
    if (monthDay !== 0) totalLastMonth = monthsWithData[monthDay - 1].hits;
    totalThisMonth = monthsWithData[monthDay].hits;

    var percentage = 0;
    if (totalThisMonth > totalLastMonth) {
      percentage = ((totalThisMonth - totalLastMonth) / totalThisMonth) * 100.0;
      change = "higher";
    } else if (totalThisMonth < totalLastMonth) {
      percentage = ((totalLastMonth - totalThisMonth) / totalLastMonth) * 100.0;
      change = "lower";
    }

    percentage = Math.floor(percentage);
    this.setState({
      data: monthsWithData,
      totaltoday: totalThisMonth,
      percentage,
      change,
    });
  };

  onOptionsChange = (e) => {
    var hitstype = e.currentTarget.value;
    this.setState({ hitstype });
    if (hitstype === "weekly") {
      //Weekly
      this.arrangeDataWeekly(this.props.users);
    } else if (hitstype === "monthly") {
      //Monthly
      this.arrangeDataMonthly(this.props.users);
    }
  };

  render() {
    var { totaltoday, change, percentage, data, hitstype } = this.state;

    var changedesc = "";
    var changeCss = "";

    if (hitstype === "weekly") {
      if (change === "higher") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_hits_recorded_today;
        else
          changedesc = `+ ${percentage}% ${LocaleStrings.analytics_text_higher_than_yesterday}`;
        changeCss = "hits-arrow-up";
      } else if (change === "lower") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_hits_recorded_today;
        else
          changedesc = `- ${percentage}% ${LocaleStrings.analytics_text_lower_than_yesterday}`;
        changeCss = "hits-arrow-down";
      }
      if (change === "same") {
        changedesc = LocaleStrings.analytics_text_no_change_from_yesterday;
      }
    } else if (hitstype === "monthly") {
      if (change === "higher") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_hits_recorder_this_month;
        else
          changedesc = `+ ${percentage}% ${LocaleStrings.analytics_text_higher_than_last_month}`;
        changeCss = "hits-arrow-up";
      } else if (change === "lower") {
        if (percentage === 0)
          changedesc = LocaleStrings.analytics_text_no_hits_recorder_this_month;
        else
          changedesc = `- ${percentage}% ${LocaleStrings.analytics_text_lower_than_last_month}`;
        changeCss = "hits-arrow-down";
      }
      if (change === "same") {
        changedesc = LocaleStrings.analytics_text_no_change_from_last_month;
      }
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default dashboard-panel">
            <div className="panel-heading dashboard-panel-head">
              <div
                className="pull-left text-capitalize dashboard-content-heading"
                style={{ borderColor: "white" }}
              >
                {LocaleStrings.analytics_text_user_hits}
              </div>
              <div className="pull-right text-capitalize addNewField">
                <ul className="header-buttons">
                  <li>
                    <span className="analytics-chart-right-subheader">
                      {LocaleStrings.weekly}
                    </span>
                    {/* <select onChange={this.onOptionsChange} name="hitstype" className="form-control">
                      <option value='weekly'>{LocaleStrings.weekly}</option>
                      <option value='monthly'>{LocaleStrings.monthly}</option>
                    </select> */}
                  </li>
                </ul>
              </div>
            </div>
            {data.length > 0 ? (
              <div className="panel-body">
                <div className="hitscount">
                  <div className="hits">
                    {totaltoday}
                    <p className={changeCss}></p>
                  </div>
                  <div className="hitsdesc">{changedesc}</div>
                </div>
                <BarChart
                  width={usersChartWidth - 100}
                  height={300}
                  data={data}
                  margin={{
                    top: 50,
                    right: 5,
                    left: 5,
                    bottom: 5,
                  }}
                >
                  <XAxis dataKey="name" />
                  <Tooltip />
                  <Bar dataKey="hits" fill="#4da1ff" />
                </BarChart>
              </div>
            ) : (
              <div className="nouser-info">
                <span>{LocaleStrings.analytics_text_no_hits_recorded}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {})(DashboardUser);
